import "./TeamItem.scss";
import { normalizeColor } from "../../../../utils/colors";

function TeamItem({ name, memberCount, color, onClick, isSelected, onDelete }) {
  const hexColor = normalizeColor(color);

  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent triggering onClick
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div
      className={`team-item ${isSelected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div
        className="color-indicator"
        style={{ backgroundColor: hexColor }}
      ></div>
      <div className="team-info">
        <div className="team-name">{name}</div>
        <div className="team-members">{memberCount} members</div>
      </div>
      <button className="delete-button" onClick={handleDeleteClick}>
        <span className="material-symbols-outlined">delete</span>
      </button>
    </div>
  );
}

export default TeamItem;
